import { JSEncrypt } from 'jsencrypt';
export var validateSupportedNetworks = function (supportedNetworksConfig, supportedNetworks) {
    var toLowerCase = function (item) { return item.toLowerCase(); };
    if (!supportedNetworks)
        return supportedNetworksConfig.map(toLowerCase);
    if (supportedNetworks.length === 0)
        return supportedNetworksConfig.map(toLowerCase);
    if (supportedNetworks.length > supportedNetworksConfig.length) {
        throw new Error("The supported networks list is not valid");
    }
    supportedNetworks.forEach(function (network) {
        var isSupported = supportedNetworksConfig.some(function (item) { return item.toLowerCase() === network.toLowerCase(); });
        if (!isSupported) {
            throw new Error("The supported network ".concat(network, " is not supported"));
        }
    });
    return supportedNetworks;
};
export var validateCurrency = function (currency, currencies) {
    var isSupported = currencies.some(function (item) { return item.toLowerCase() === currency.toLowerCase(); });
    if (!isSupported) {
        throw new Error("The currency \"".concat(currency, "\" is not supported, you have to use one of these currencies: ").concat(currencies));
    }
    return currency;
};
export var getApplePayRequest = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var transaction = _a.transaction, customer = _a.customer, supportedNetworks = _a.supportedNetworks, merchantCapabilities = _a.merchantCapabilities, countryCode = _a.countryCode, name = _a.name, features = _a.features;
    return {
        countryCode: countryCode,
        currencyCode: transaction.currency,
        merchantCapabilities: merchantCapabilities,
        supportedNetworks: supportedNetworks,
        billingContact: customer && {
            phoneNumber: ((_c = (_b = customer.contact) === null || _b === void 0 ? void 0 : _b.phone) === null || _c === void 0 ? void 0 : _c.countryCode) || '' + ((_e = (_d = customer.contact) === null || _d === void 0 ? void 0 : _d.phone) === null || _e === void 0 ? void 0 : _e.number),
            emailAddress: (_f = customer.contact) === null || _f === void 0 ? void 0 : _f.email,
            givenName: ((_g = customer.name) === null || _g === void 0 ? void 0 : _g.length) ? (_h = customer.name[0]) === null || _h === void 0 ? void 0 : _h.first : '',
            familyName: ((_j = customer.name) === null || _j === void 0 ? void 0 : _j.length) ? (_k = customer.name[0]) === null || _k === void 0 ? void 0 : _k.last : ''
        },
        total: {
            amount: Number(transaction.amount),
            label: name
        },
        supportsCouponCode: features.supportsCouponCode,
        couponCode: transaction.couponCode,
        requiredShippingContactFields: features === null || features === void 0 ? void 0 : features.shippingContactFields,
        shippingMethods: transaction.shipping,
        lineItems: (_l = transaction.items) === null || _l === void 0 ? void 0 : _l.map(function (item) {
            var _a, _b, _c, _d, _e, _f;
            return ({
                type: item.type,
                label: item.label,
                amount: item.amount,
                paymentTiming: item.paymentTiming,
                recurringPaymentStartDate: (_a = item.scheduledPayment) === null || _a === void 0 ? void 0 : _a.recurringStartDate,
                recurringPaymentIntervalUnit: (_b = item.scheduledPayment) === null || _b === void 0 ? void 0 : _b.recurringIntervalUnit,
                recurringPaymentIntervalCount: (_c = item.scheduledPayment) === null || _c === void 0 ? void 0 : _c.recurringIntervalCount,
                recurringPaymentEndDate: (_d = item.scheduledPayment) === null || _d === void 0 ? void 0 : _d.recurringEndDate,
                deferredPaymentDate: (_e = item.deferredPayment) === null || _e === void 0 ? void 0 : _e.deferredPaymentDate,
                automaticReloadPaymentThresholdAmount: (_f = item.automaticReloadPayment) === null || _f === void 0 ? void 0 : _f.thresholdAmount
            });
        })
    };
};
export var getApplePayPaymentMethod = function (paymentMethods) {
    var paymentMethod = paymentMethods.find(function (_a) {
        var name = _a.name, payment_type = _a.payment_type;
        return [name, payment_type].some(function (item) { return item.toLowerCase() === 'apple_pay'; });
    });
    if (!paymentMethod) {
        throw new Error('Apple Pay is not configured in your payment options');
    }
    return paymentMethod;
};
export var rsaSetup = function (key) {
    var rsa = new JSEncrypt();
    rsa.setPublicKey(key);
    return function (string) {
        if (typeof string !== 'string')
            throw new Error('string should be from type string');
        var encrypted = rsa.encrypt(string);
        if (!encrypted)
            throw new Error('encryption data reached max allowed length');
        return encrypted;
    };
};
export function generateApplicationHeader(obj) {
    return Object.keys(obj)
        .map(function (key) { return "".concat(key, "=").concat(obj[key]); })
        .join('|');
}
